import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { AccountService } from './account.service';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const accountResolverService: ResolveFn<any> = (route, state) => {
  const accountService = inject(AccountService); 

  return getData();

  function getData(): Observable<any> {
    return forkJoin({
      accountsSummary: accountService.accountSummary().pipe(
        catchError(err => {
          console.error('Error fetching account summary', err);
          return of(null); // Fallback value
        })
      ),
      otherAccounts: accountService.otherAccounts().pipe(
        catchError(err => {
          console.error('Error fetching other accounts', err);
          return of(null); // Fallback value
        })
      )
    }).pipe(
      map(data => data) // You can structure the data if necessary
    );
  }
};